import Api from '../Api'


export class ApiInv extends Api{
    constructor(){
        super()
    }

    async getCategorias(id=-1){
        return await super.get("categoria", id)
    }

    async saveCategoria(obj){
        return await super.save("categoria", obj)
    }

    async delCategoria(id){
        return await super.delete("categoria", id)
    }


    async getSubCategorias(id=-1){
        return await super.get("subcategoria", id)
    }

    async saveSubCategoria(obj){
        return await super.save("subcategoria", obj)
    }

    async delSubCategoria(id){
        return await super.delete("subcategoria", id)
    }


    async getProdutos(id=-1){
        return await super.get("produto", id)
    }

    async getProdutoByName(termo){
        return await super.get("produto/by-descricao", termo)
    
    }
    async getProdutoBySubcategoria(termo){
        return await super.get("produto/by-subcategoria", termo)
    }

    async saveProduto(obj){
        return await super.save("produto", obj)
    }

    async delProduto(id){
        return await super.delete("produto", id)
    }

    async getEmpresas(id=-1){
        return await super.get("empresa", id)
    }

    async saveEmpresa(obj){
        return await super.save("empresa", obj)
    }

    async delEmpresa(id){
        return await super.delete("empresa", id)
    }
}